module.exports = __webpack_public_path__ + "img/bildin-logo-white.669f761a.svg";